export const BillingClients = [
    {value: "NO_CLIENT", label: "Nincs"},
    {value: "CLIENT_BILLINGO", label: "Billingo"},
    {value: "CLIENT_SZAMLAZZ", label: "Számlázz.hu"},
];

export default (BillingClients);
